import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ProfileCard } from '../../components/Dashboard/ProfileCard';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../../hooks/Helper/GlobalContext';
import { useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { getOrganizationsByContactId } from '../../redux/thunks/organizationThunks';
import { MyOrganizationCardAdvanceCCo } from '../../components/Cards/MyOrganizationCardAdvanceCCo';
import { NotificationBanner } from '../../components/NotificationBanner/NotificationBanner';
import { formatAddress } from '../../tools/utils';
import {  Loader } from '../../components/Loader';
import { getUser } from '../../redux/slices/contactSlice';
export default function CCOprolandingpageAdvance({ headerMarginTop }: { headerMarginTop: number }) {

  const {photoBannerVisible,PhotoBannerMessage} = useGlobalContext();
  const { t } = useTranslation();

const [activeIndex, setActiveIndex] = useState<number | null>(null);

     const dispatch = useDispatch<AppDispatch>();

    const { organizations,error:orgError,loading:isOrgLoading } = useSelector((state: RootState) => state.organization);

    useEffect( () => {
      dispatch(getOrganizationsByContactId());
    }, []);

  const pendingOrgs = organizations.filter((org: any) => org?.StatusReason === 'Pending');
  const approvedOrgs = organizations.filter((org: any) => org?.StatusReason === 'Approved');
  const { contact,loading,error} = useSelector((state: RootState) => state.contact);
    useEffect(() => {
       if(contact===null && !loading && !error){
        dispatch(getUser());
       }
    },[]);
  return (
    
    <div>
 
      <div id="main-content" style={{ marginTop: headerMarginTop }}>
        <div className="cco_content_area cco_content_area_0">
          <article className="react-container">
              <NotificationBanner
              background="red"
              showBanner={photoBannerVisible}
              message={PhotoBannerMessage}
              color="white"
              margin-Left="20"
              type="photo"
            />
            <div className="cco_section cco_section_0">
        
    <div className="cco_row cco_row_4"  >
        <div className="cco_col">
          <div className="cco_text cco_text_0">
            <div className="cco_text_inner">
              <strong> {t('MyCCOPro.breadcrumb')}</strong>
            </div>
          </div>
        </div>
      </div>
              <ProfileCard />
              

              <div className="cco_row cco_row_7">
                <div className="cco_col cco_col_6">
                  <div className="cco_text cco_text_10">
                    <div className="cco_text_inner">
                     
                      <p>
  {t('MyCCOPro.certConnectDescriptionPart1')}
  <a
    href="https://www.nccco.org/PPA"
    target="_blank"
    rel="noopener noreferrer"
  >
    {t('MyCCOPro.certConnectDescriptionLinkText')}
  </a>
  {t('MyCCOPro.certConnectDescriptionPart2')}
</p>
                      
                       
                    </div>
                  </div>
                </div>
              </div>
                  <div className="cco_row cco_row_7">
                <div className="cco_col cco_col_6">
                  <div className="cco_text cco_text_10">
                    <div className="cco_text_inner">
                 
                     
                     {
                    approvedOrgs.length === 0 && pendingOrgs.length === 0 &&  <h2>
                        <strong>{t('MyCCOPro.myOrganizations')}</strong>
                      </h2>}
                       
                    </div>
                  </div>
                </div>
              </div>
              {
             approvedOrgs.length === 0 && pendingOrgs.length === 0 && !isOrgLoading && 
              <div className="cco_row cco_row_3">
                                          <div className="cco_col">
                                          
                      
                                              <ul className="cco_menu cco_menu_4">
                                                  <li className="cco_menu_item cco_menu_item_icon cco_menu_item_icon_plus">
                                                      <Link  to="/CreateOrganization" >{t('MyCCOPro.addNewOrganization')}</Link>
                                                  </li>
                                              </ul>
                                          </div>
                                      </div>}

              {isOrgLoading ? (
                <div className="cco_row cco_row_3">
                  <Loader />
                </div>
              ) : orgError ? (
                <div className="cco_row cco_row_3">
                  <p>{orgError}</p>
                </div>
              ) : organizations.length < 1 ? (
              null
              ) : (
                <>
                  {pendingOrgs.length > 0 && (
                    <>
                      <div className="cco_row cco_row_7">
                        <div className="cco_col cco_col_6">
                          <div className="cco_text cco_text_10">
                            <div className="cco_text_inner">
                              <h2>
                                <strong>{t('MyCCOPro.myPendingApprovalOrgs')}</strong>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="cco_row cco_row_3">
                        <div className="cco_col">
                          <ul className="cco_accordion">
                       {organizations
  .filter(item => item.StatusReason === 'Pending')
  .map((item, index) => (
  <li
  key={item.OrganizationId || index}
  className={classNames('cco_accordion_item', { active: activeIndex === index })}
>
  <div className="cco_accordion_item_header">
    <div className="cco_text cco_text_3">
      <div className="cco_text_inner">
        <h3>
          {item.Name || '[Company Name]'}
          <span> - </span>
          {formatAddress({
            Zip: item.ZipCode,
            City: item.City,
            Type: 'Formatted',
            Street1: item.Address1,
            Street2: item.Address2,
            State: item.StateProvince?.Name || '',
          })}
        </h3>
      </div>
    </div>
    <button
      className="cco_accordion_item_toggle"
      onClick={() => setActiveIndex(activeIndex === index ? null : index)}
    >
      <span className="cco_accordion_item_toggle_text">{t('MyCCOPro.view')}</span>
    </button>
  </div>

  {/* Only show body if current index is active */}
  {activeIndex === index && (
    <div className="cco_accordion_item_body">
      <div className="cco_accordion_item_body_inner">
        <table className="cco_table cco_table_1">
          <tbody className="cco_table_body">
            <tr className="cco_table_row">
              <td className="cco_table_cell cco_table_cell_medium">
                <div className="cco_blurb cco_blurb_0">
                  <div className="cco_blurb_label">{t('MyCCOPro.organizationName')}</div>
                  <div className="cco_blurb_value">
                    <strong>{item.Name}</strong>
                  </div>
                </div>
                <div className="cco_blurb cco_blurb_0">
                  <div className="cco_blurb_label">{t('MyCCOPro.address')}</div>
                  <div className="cco_blurb_value">
                    <strong>
                      {formatAddress({
                        Zip: item.ZipCode,
                        City: item.City,
                        Type: 'Formatted',
                        Street1: item.Address1,
                        Street2: item.Address2,
                        State: item?.StateProvince?.Name || '',
                      })}
                    </strong>
                  </div>
                </div>
              </td>
              <td className="cco_table_cell cco_table_cell_small"></td>
              <td className="cco_table_cell cco_table_cell_small">
                <div className="cco_blurb cco_blurb_align_right cco_blurb_0">
                  <div className="cco_blurb_label">{t('MyCCOPro.status')}</div>
                  <div className="cco_blurb_value">
                    <strong>{item.StatusReason}</strong>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )}
</li>

  ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  )}

                {approvedOrgs.length > 0 && (
                    <>
                  
                      <div className="cco_row cco_row_7">
                        <div className="cco_col cco_col_6">
                          <div className="cco_text cco_text_10">
                            <div className="cco_text_inner">
                              <h2>
                                <strong>{t('MyCCOPro.myApprovedOrgs')}</strong>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                       <div className="cco_row cco_row_3"style={{ marginTop: '20px' }} >
                       <div className="cco_group cco_group_myCredential">
      {approvedOrgs.map((item, index) => (
        <MyOrganizationCardAdvanceCCo
          key={item.OrganizationId}
          index={index}
          connection={item} 
        />
      ))}
    </div>
    </div>
                 
                    </>
                  )}
                </>
              )}
            </div>
          </article>
        </div>
      </div>
       
    </div>
  );
}
